export default {
  year: 2021,
  edition: "제 17회",
  date: "2021년 11월 27일 토요일",
  time: "오후 2시 ~ 5시",
  location: "다산관 D104/D105",
  links: {
    problems: {
      PDF: {
        Master: "/downloads/spc/2021/master.pdf",
        Champion: "/downloads/spc/2021/champion.pdf",
      },
      BOJ: "https://www.acmicpc.net/category/detail/2884",
    },
    solutions: {
      PDF: "/downloads/spc/2021/solutions.pdf",
    },
  },
  authors: ["강효규", "박수현", "이상원", "이선호", "이준석", "조원빈"],
  contests: [
    {
      title: "SPC 2021 Master",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "6", "손기령"],
        ["2", "6", "박준서"],
        ["3", "5", "유호영"],
        ["4", "4", "권지은"],
        ["5", "4", "장성"],
        ["6", "4", "김서인"],
      ],
      award: ["gold", "silver", "silver", "bronze", "bronze", "bronze"],
      links: [["스코어보드", "https://www.acmicpc.net/contest/scoreboard/724"]],
    },
    {
      title: "SPC 2021 Champion",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "5", "전해성"],
        ["2", "5", "김정모"],
        ["3", "4", "정성엽"],
        ["4", "4", "조명재"],
        ["5", "3", "천성원"],
        ["6", "3", "한상필"],
        ["7", "3", "이원표"],
      ],
      award: [
        "winner",
        "gold",
        "silver",
        "silver",
        "bronze",
        "bronze",
        "bronze",
      ],
      links: [["스코어보드", "https://www.acmicpc.net/contest/scoreboard/726"]],
    },
  ],
};
